var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: { title: "Widgets Center", width: "900px", footer: null },
      on: { cancel: _vm.closeModal },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "widgets-center" }, [
        _c("div", { staticClass: "categories" }, [
          _c("h3", [_vm._v("Kategoriler")]),
          _vm._v(" "),
          _c("ul", { staticClass: "category-list" }, [
            _c("li", { staticClass: "category-item active" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Önerilen"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Güncel Kalma"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Motivasyon"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [_vm._v("Medya")]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [_vm._v("Kişisel")]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Supsis Uygulamaları"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Marketplace Uygulamaları"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "widgets-container" }, [
          _c("h2", [_vm._v("Önerilen")]),
          _vm._v(" "),
          _c("div", { staticClass: "widgets-grid" }, [
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/chart.png",
                      alt: "Grafik Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [_vm._v("Grafik")]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(
                    "Tablolarınızdaki verileri görsel olarak göstermek için grafik widget'ı oluşturun"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("chart")
                      },
                    },
                  },
                  [_vm._v("Widget Ekle")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/numbers.png",
                      alt: "Sayılar Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [_vm._v("Sayılar")]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(
                    "Tüm sayı sütunlarında hızlı bir genel bakış elde edin"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("numbers")
                      },
                    },
                  },
                  [_vm._v("Widget Ekle")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/text.png",
                      alt: "Metin Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [_vm._v("Metin")]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v("Panonuza özel metin içeriği ekleyin"),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("text")
                      },
                    },
                  },
                  [_vm._v("Widget Ekle")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/countdown.png",
                      alt: "Geri Sayım Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v("Geri Sayım"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(
                    "Önemli son tarihleri takip etmek için geri sayım sayacı ekleyin"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("countdown")
                      },
                    },
                  },
                  [_vm._v("Widget Ekle")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/iframe.png",
                      alt: "Iframe Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [_vm._v("Iframe")]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v("Panonuza harici web içeriği yerleştirin"),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("iframe")
                      },
                    },
                  },
                  [_vm._v("Widget Ekle")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/youtube.png",
                      alt: "Youtube Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [_vm._v("Youtube")]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v("Panonuza Youtube videoları yerleştirin"),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("youtube")
                      },
                    },
                  },
                  [_vm._v("Widget Ekle")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }